import * as React from "react";
import { forwardRef } from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7 17L17 7", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7 7H17V17", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
